var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegabytesIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 46 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 3,
    d: "M2 2h42v22H2z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Raleway-ExtraBold, Raleway",
    fontSize: 20,
    fontWeight: 600,
    fill: "currentColor",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.06,
    y: 19
  }, "MB")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegabytesIcon);
export default __webpack_public_path__ + "static/media/megabytes-icon.0743a083f0865e54b2b6dab843ef8ffa.svg";
export { ForwardRef as ReactComponent };